// src/i18n/es/errorDefinitions.ts

/**
 * Spanish translations for Error Definitions management
 */
const errorDefinitions = {
  name: 'Definiciones de Error',
  title: 'Definiciones de Error',
  subtitle: 'Gestionar c\u00f3digos de error, traducciones y niveles de severidad',
  empty: 'No se encontraron definiciones de error',

  // Actions
  actions: {
    create: 'A\u00f1adir Definici\u00f3n',
    edit: 'Editar',
    delete: 'Eliminar',
  },

  // Fields
  fields: {
    errorCode: 'Código de Error',
    severity: 'Severidad',
    category: 'Categoría',
    nature: 'Naturaleza',
    title: 'Título',
    description: 'Descripción',
    recommendation: 'Recomendación',
    translations: 'Traducciones',
    languages: 'idiomas',
    language: 'Idioma',
    actions: 'Acciones',
    createdAt: 'Creado',
    updatedAt: 'Actualizado',
    conditions: 'Condiciones',
    metadataKey: 'Clave de metadato',
    metadataValue: 'Valor',
    operator: 'Operador',
    conditionActive: 'Activa',
  },

  // Condition count chip (pluralized)
  conditionCount: '%{smart_count} condición |||| %{smart_count} condiciones',

  // Condition operators
  operator: {
    equals: 'Igual a',
  },

  // Filters
  filters: {
    search: 'Buscar por c\u00f3digo o t\u00edtulo',
    severity: 'Severidad',
    category: 'Categor\u00eda',
    all: 'Todos',
  },

  // Severity levels
  severity: {
    critical: 'Crítico',
    info: 'Informativo',
    warning: 'Aviso',
  },

  // Nature types
  nature: {
    error: 'Error',
    operational: 'Operacional',
    informational: 'Informativo',
  },

  // Categories (must match backend ErrorCategory enum)
  category: {
    encoder: 'Codificador',
    mechanical: 'Mecánico',
    card: 'Tarjeta',
    room: 'Habitación',
    network: 'Red',
    system: 'Sistema',
    pms: 'Sistema de reservas',
    locks: 'Cerraduras',
    qr: 'Código QR',
    payments: 'Pagos',
    identification: 'Identificación',
  },

  // Status
  status: {
    active: 'Activo',
    inactive: 'Inactivo',
  },

  // Dialog
  dialog: {
    createTitle: 'Crear Definición de Error',
    editTitle: 'Editar Definición de Error',
    basicInfo: 'Información Básica',
    translations: 'Traducciones',
    addTranslation: 'Añadir Traducción',
    conditions: 'Condiciones',
    addCondition: 'Añadir Condición',
    noConditions: 'Sin condiciones. Esta definición se aplica a cualquier evento con este código de error.',
    errorCodeHelp: 'Código único en MAYÚSCULAS (ej. MECH_JAM)',
    titleHelp: 'Título corto y descriptivo para el error',
    descriptionHelp: 'Explicación detallada del significado de este error',
    recommendationHelp: 'Acción recomendada para que los operadores resuelvan este error',
  },

  // Help texts for popovers
  help: {
    basicInfo: 'Define el código de error y su clasificación. El código debe ser único y en formato mayúsculas.',
    severity: 'Crítico requiere atención inmediata. Aviso indica una situación que conviene revisar pero no urgente. Informativo no requiere acción.',
    category: 'Categoriza el error para facilitar el filtrado e identificación del tipo de problema.',
    nature: 'Determina si cuenta como error real en los KPIs. Los eventos "Operacionales" (ej. hopper vacío) son estados esperados, no fallos.',
    translations: 'Proporciona traducciones para cada idioma. El inglés es obligatorio como idioma por defecto.',
    conditions: 'Restringen cuándo se aplica esta definición según los metadatos del evento. Si añade varias, deben cumplirse todas (Y lógico). Sin condiciones, la definición se aplica a cualquier evento con este código de error.',
  },

  // Placeholders
  placeholders: {
    title: 'ej. Atasco de papel',
    description: 'ej. El papel está atascado en el mecanismo dispensador',
    recommendation: 'ej. Abra la tapa y retire el papel atascado',
    metadataKey: 'ej. reason',
    metadataValue: 'ej. DocumentNotValid',
  },

  // Validation
  validation: {
    errorCodeRequired: 'El c\u00f3digo de error es obligatorio',
    errorCodeFormat: 'El c\u00f3digo de error debe ser letras may\u00fasculas, n\u00fameros y guiones bajos',
    titleRequired: 'Se requiere al menos un t\u00edtulo',
    englishRequired: 'Se requiere la traducci\u00f3n en ingl\u00e9s con t\u00edtulo',
    conditionIncomplete: 'Cada condici\u00f3n debe tener clave y valor',
  },

  // Notifications
  notifications: {
    created: 'Definici\u00f3n de error creada correctamente',
    updated: 'Definici\u00f3n de error actualizada correctamente',
    deleted: 'Definici\u00f3n de error eliminada correctamente',
  },

  // Errors
  errors: {
    loadFailed: 'Error al cargar las definiciones de error',
    saveFailed: 'Error al guardar la definici\u00f3n de error',
    deleteFailed: 'Error al eliminar la definici\u00f3n de error',
    noPermission: 'No tienes permiso para gestionar definiciones de error',
  },
};

export default errorDefinitions;
